// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-28T15:51:43.480Z
// Property: Liberty Pointe (ID: 6321002732584960)
// Collections: 42 amenities, 6 floorplans (live), 27 photos, 39 POIs, 4 reviews, 2 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6321002732584960",
  "property_external_id": "924383",
  "property_zillow_url": "https://www.zillow.com/apartments/oklahoma-city-ok/liberty-pointe/5Z7W95/",
  "property_apartments_url": "https://www.apartments.com/liberty-pointe-oklahoma-city-ok/wm1c47k",
  "property_google_business_url": "https://www.google.com/maps/place/Liberty+Pointe/data=!4m2!3m1!1s0x0:0x62e0f9d6e54f3640?sa=X&ved=2ahUKEwi2t6D_zriSAxU2TDABHcEQM2sQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47607690395",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "liberty-pointe",
  "property_name": "Liberty Pointe",
  "property_website_url": "https://www.libertypointeapartmenthomes.com",
  "property_domain": "https://www.libertypointeapartmenthomes.com",
  "property_address": "6600 SE 74th. St.",
  "property_full_address": "6600 SE 74th. St., Oklahoma City, OK, 73135",
  "property_address_1": "6600 SE 74th. St.",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73135",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Kennington-Ridgefield",
  "property_address_latitude": "35.3912",
  "property_address_longitude": "-97.4087",
  "property_email": "libertypointe@weidner.com",
  "property_phone": "4055846182",
  "property_call_tracking_phone": "405-759-4888",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Liberty Pointe in Oklahoma City, every detail is designed for your comfort. Choose from spacious one, two, or three-bedroom floor plans and enjoy luxurious amenities like a sparkling pool, fitness center, and serene courtyard. Connect with neighbors at social events or unwind on the sundeck. Your perfect home awaits!",
  "property_long_description": "Welcome to Liberty Pointe, your ideal apartment community in the heart of Oklahoma City, OK. Our thoughtfully designed floor plans include one, two, and three-bedroom apartments, perfect for individuals, couples, and families alike. At Liberty Pointe, you will experience a lifestyle enriched by a plethora of exceptional amenities that cater to your every need.\n\nDive into relaxation at our inviting pool or break a sweat in our fully-equipped fitness center. Enjoy convenience at its best with features like controlled access, key fob entry, and 24-hour on-site maintenance. Our clubhouse and multi-use room provide spaces for social gatherings, while the planned social activities foster a sense of community among residents. \n\nFor those who love the outdoors, our sun-drenched sundeck and serene picnic area offer the perfect backdrop for leisure, complemented by our beautifully landscaped courtyard. Pet owners will appreciate our convenient pet washing station, ensuring that your furry friends feel right at home too! Plus, with community-wide Wi-Fi, EV charging stations, and an on-site ATM, staying connected and accessing services has never been easier.\n\nAt Liberty Pointe, we prioritize your comfort and convenience. Our dedicated property management team is always here to assist you, whether it's with package services, door-to-door trash pickup, or our exclusive breakfast/coffee concierge.\n\nFind your new home today—browse our availability or schedule a tour to visit our community! Liberty Pointe is ready to welcome you to a lifestyle of comfort and convenience.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a6-65a4-76a8-a18d-a4bf72b0167b.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and surrounding apartment buildings.",
    "public_id": "019d01a6-65a4-76a8-a18d-a4bf72b0167b",
    "storage_key": "property/6321002732584960/019d01a6-65a4-76a8-a18d-a4bf72b0167b.webp",
    "width": 2560,
    "height": 936
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "324",
  "property_year_built": "2013",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.37037037037037",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://libertypointeapartmenthomes.securecafe.com/onlineleasing/liberty-pointe-4/floorplans.aspx",
  "property_resident_portal_url": "https://libertypointeapartmenthomes.securecafenet.com/residentservices/liberty-pointe-4/userlogin",
  "property_apply_now_url": "https://libertypointeapartmenthomes.securecafe.com/onlineleasing/liberty-pointe-4/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a4-bb15-7328-8530-502070e570af.webp",
  "property_primary_logo_media": {
    "alt_text": "Liberty Pointe Apartment Homes logo",
    "public_id": "019d01a4-bb15-7328-8530-502070e570af",
    "storage_key": "property/6321002732584960/019d01a4-bb15-7328-8530-502070e570af.webp",
    "width": 170,
    "height": 75
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a6-5a7b-710b-b3ee-0b8ef6d2992b.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d01a6-5a7b-710b-b3ee-0b8ef6d2992b",
    "storage_key": "property/6321002732584960/019d01a6-5a7b-710b-b3ee-0b8ef6d2992b.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a6-75b5-7515-9919-b71b0631f099.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Liberty Pointe Apartment Homes logo.",
    "public_id": "019d01a6-75b5-7515-9919-b71b0631f099",
    "storage_key": "property/6321002732584960/019d01a6-75b5-7515-9919-b71b0631f099.webp",
    "width": 170,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a6-859c-77a8-9a4b-c28b79311101.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Liberty Pointe Apartment Homes logo.",
    "public_id": "019d01a6-859c-77a8-9a4b-c28b79311101",
    "storage_key": "property/6321002732584960/019d01a6-859c-77a8-9a4b-c28b79311101.webp",
    "width": 170,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#646868",
  "property_secondary_color": "#f7f5f0",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1189",
  "property_sqft_min": "662",
  "property_sqft_max": "1189",
  "property_price_range": "1118 - 3220",
  "property_price_min": "1118",
  "property_price_max": "3220",
  "property_available_units": 21,
  "property_facebook_url": "https://www.facebook.com/LibertyPointeApartments",
  "property_instagram_url": "https://www.instagram.com/libertypointeapthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJsUzqC08-socRQDZP5db54GI",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Liberty Pointe",
  "property_home_romance_title": "Embrace Blissful Living in Your Ideal Apartment Home",
  "property_home_amenities_blurb": "Welcome to Liberty Pointe in vibrant Oklahoma City, where comfort meets convenience. Choose from stunning one, two, or three-bedroom apartments, each crafted with modern finishes like granite countertops and spacious walk-in closets. Enjoy our plethora of amenities, including a pool, fitness center, and pet-friendly areas, all designed for an enriching lifestyle.",
  "property_home_floorplans_blurb": "At Liberty Pointe in vibrant Oklahoma City, find your ideal living space among our thoughtfully designed one, two, and three-bedroom apartments. Each layout maximizes comfort and style, making it easy to envision your new home. Browse our available options today and embrace a lifestyle of convenience and community!",
  "property_home_gallery_blurb": "Welcome to Liberty Pointe, where comfort meets community in vibrant Oklahoma City. Choose from spacious one to three-bedroom floor plans and indulge in exceptional amenities like a resort-style pool, state-of-the-art fitness center, and inviting picnic areas. Experience life elevated—imagine your new home today!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Oklahoma City, Liberty Pointe offers a vibrant neighborhood rich in local favorites. From cozy one-bedroom retreats to spacious three-bedroom apartments, find the perfect floor plan for your lifestyle. Uncover charming cafes, parks, and entertainment hotspots just steps from your door—your adventure awaits!",
  "property_home_reviews_blurb": "At Liberty Pointe in Oklahoma City, our residents consistently rave about the welcoming atmosphere and friendly service. One satisfied tenant shared, \"I love the apartments and always friendly service when I need it.\" Enjoy on-site amenities like a tranquil pond, pool, and gym, all designed for relaxation and recreation.",
  "property_neighborhood_blurb": "At Liberty Pointe in Oklahoma City, you'll thrive amidst vibrant surroundings that blend convenience with community. From the serene trails of Buck Thomas Park to the enriching exhibits at the Museum of Osteology, local gems await around every corner. Dive into nearby attractions and discover the lifestyle you deserve!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Liberty Pointe in Oklahoma City, your dream home awaits! Choose from stylish one, two, or three-bedroom floor plans and indulge in our inviting amenities. Dive into our sparkling pool, unwind at the spa, or gather with friends in the clubhouse. Experience a lifestyle tailored for comfort and convenience.",
  "property_applynow_blurb": "At Liberty Pointe in Oklahoma City, discover your ideal living space with versatile one, two, or three-bedroom floor plans. Enjoy exceptional amenities like a relaxing pool, modern fitness center, and inviting clubhouse. With convenient online services and a vibrant community atmosphere, your perfect home awaits—lease online today!",
  "property_contactus_blurb": "At Liberty Pointe in vibrant Oklahoma City, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Let our leasing team help you find your perfect home. Have questions? Reach out to us today, and take the first step towards elevating your living experience!",
  "property_faqs_blurb": "At Liberty Pointe in Oklahoma City, our diverse floor plans— from cozy one-bedrooms to spacious three-bedrooms—accommodate every lifestyle. Curious about amenities, leasing terms, or community events? Our FAQs page is your go-to resource for everything you need to know. Dive in to unlock the full Liberty Pointe experience!",
  "property_floorplans_blurb": "At Liberty Pointe in Oklahoma City, your ideal space awaits! Choose from our stylish one, two, or three-bedroom floor plans that seamlessly blend comfort and modern living. Each design offers a unique vibe to match your lifestyle. Ready to find your perfect home? Browse our available layouts today!",
  "property_gallery_blurb": "At Liberty Pointe in Oklahoma City, picture vibrant living with our stunning one, two, and three-bedroom apartments. Dive into relaxation by the pool, stay active in our fitness center, or unwind in the clubhouse. With luxurious amenities and planned social activities, your dream lifestyle awaits—come envision your new home!",
  "property_interactivemap_blurb": "Experience the vibrant lifestyle at Liberty Pointe in Oklahoma City, where spacious one, two, and three-bedroom apartments meet a wealth of amenities. Unwind by the pool, stay fit in our center, or enjoy social events in the clubhouse. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Liberty Pointe in Oklahoma City, your furry friends find their perfect home alongside you! Enjoy spacious apartments nestled in a vibrant community, complete with pet-friendly features and nearby parks for those playful outings. Experience a lifestyle that embraces both comfort and companionship—where every day feels like a new adventure!",
  "property_referafriend_blurb": "At Liberty Pointe in Oklahoma City, your ideal living space awaits! With thoughtfully designed one, two, and three-bedroom floor plans, you can find the perfect home for you and your loved ones. Share the joy of community living—refer a friend today, because great friends make great neighbors!",
  "property_residentaccess_blurb": "At Liberty Pointe in Oklahoma City, your ideal living space awaits! From cozy one-bedroom havens to spacious three-bedroom retreats, our community has floor plans tailored for every lifestyle. Access your resident portal now to streamline your rent payments, schedule maintenance, and enjoy effortless living at its finest!",
  "property_reviews_blurb": "At Liberty Pointe in Oklahoma City, our residents rave about the welcoming atmosphere and attentive service. With five-star ratings highlighting our friendly staff and exceptional amenities like a serene pond for walks and a refreshing pool, you'll find the perfect blend of comfort and community. Join us and experience it yourself!",
  "property_created_at": "1752256807734",
  "property_scheduletour_blurb": "Nestled in the heart of Oklahoma City, Liberty Pointe offers thoughtfully designed one, two, and three-bedroom floor plans that perfectly blend comfort and style. Experience vibrant living in a thriving community—schedule a tour today and see what our residents love about calling Liberty Pointe home!",
  "property_thankyou_blurb": "Thank you for reaching out! At Liberty Pointe in Oklahoma City, we offer an array of thoughtfully designed apartments, including one, two, and three-bedroom options. Embrace a vibrant lifestyle tailored to your needs—your new home is just around the corner, and our team will connect with you soon!",
  "property_virtualtours_blurb": "At Liberty Pointe in Oklahoma City, you’ll find thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Envision your future home and experience our vibrant community from the comfort of your screen. Take a virtual tour today and step closer to your ideal living space!",
  "property_copyright": "2025 All Rights Reserved. Liberty Pointe",
  "property_seo_title_home": "Liberty Pointe | Apartments in Oklahoma City, OK",
  "property_seo_description_home": "Experience the vibrant lifestyle at Liberty Pointe in Oklahoma City, where luxury meets comfort in our diverse floor plans—one, two, or three bedrooms to suit your needs. Enjoy top-notch amenities like a refreshing pool, state-of-the-art fitness center, and lively clubhouse, all designed for your convenience. With 24-hour access, on-site maintenance, and pet-friendly features including a washing station, every day feels like a getaway. Elevate your living experience amongst lush courtyards and sun-drenched sundecks. Ready to make your move? Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Oklahoma City, OK",
  "property_seo_description_floorplans": "Find your ideal living space at Liberty Pointe in Oklahoma City, OK! With a variety of thoughtfully designed floor plans including one, two, and three-bedroom options, we cater to all lifestyles. Each apartment is crafted for comfort and style, making it easy to call Liberty Pointe home. Browse our available homes and see which layout speaks to you!",
  "property_seo_title_amenities": "Amenities | Oklahoma City, OK Apartments for Rent",
  "property_seo_description_amenities": "\"Elevate your living experience at Liberty Pointe in Oklahoma City, where modern comfort meets vibrant community life. Choose from spacious one, two, or three-bedroom floor plans and dive into a world of exceptional amenities, from a refreshing pool and state-of-the-art fitness center to a cozy clubhouse and inviting picnic area. Enjoy 24-hour access, controlled entry, and the convenience of on-site services—all designed to enhance your lifestyle. Ready to make Liberty Pointe your new home? Our amenities await!\"",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, OK",
  "property_seo_description_gallery": "\"Step into the vibrant community at Liberty Pointe in Oklahoma City, where each photo tells a story of comfort and convenience. Whether you choose a one, two, or three-bedroom apartment, enjoy top-notch amenities like a refreshing pool, state-of-the-art fitness center, and a cozy clubhouse. Bask in the sun on the sundeck or gather with friends in the picnic area. With features like EV charging stations, a pet washing station, and 24-hour access, your new home is designed for modern living. Picture yourself thriving here!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Liberty Pointe Apartments",
  "property_seo_description_virtualtours": "Step into a new lifestyle at Liberty Pointe in Oklahoma City! Our thoughtfully designed one, two, and three-bedroom floor plans offer the perfect blend of comfort and convenience. Immerse yourself in our vibrant community with a captivating virtual tour, where every corner is crafted for your satisfaction. Click now to view your future home!",
  "property_seo_title_interactivemap": "Interactive Map | Liberty Pointe Apartments",
  "property_seo_description_interactivemap": "\"Uncover your ideal living space at Liberty Pointe, Oklahoma City's premier apartment community. Choose from spacious one, two, and three-bedroom floor plans, all nestled within a vibrant setting that boasts top-notch amenities. From a refreshing pool and state-of-the-art fitness center to community-wide WiFi and planned social activities, life here is designed for comfort and convenience. Ready to call Liberty Pointe home? Utilize our interactive community map to find your perfect apartment, view pricing, and embark on your new lifestyle!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, OK",
  "property_seo_description_neighborhood": "Experience the vibrant charm of Liberty Pointe in Oklahoma City, OK! Nestled in a lively neighborhood, our community offers easy access to local favorites, parks, and cultural hotspots. Whether you live in a cozy one-bedroom or a spacious three-bedroom, you’ll enjoy a lifestyle rich in convenience and excitement. Uncover everything our surroundings have to offer—dining, shopping, and recreation—right at your doorstep!",
  "property_seo_title_contact": "Contact Us | Liberty Pointe",
  "property_seo_description_contact": "\"Unlock the doors to your dream home at Liberty Pointe in Oklahoma City, where comfort meets style. Whether you're seeking a cozy one-bedroom, a spacious two-bedroom, or a family-friendly three-bedroom layout, our floor plans cater to your lifestyle. Ready to learn more? Have questions? Contact our leasing team today!\"",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, OK",
  "property_seo_description_faqs": "\"At Liberty Pointe in Oklahoma City, we're dedicated to providing a vibrant living experience tailored to your lifestyle. With spacious one, two, and three-bedroom floor plans, along with an array of modern amenities like a refreshing pool, fitness center, and cozy lounge, you’ll feel right at home. Enhance your living experience with our community events, pet washing station, and 24-hour access. Have questions? Our FAQs page is perfect for finding all the answers you need about our exceptional community!\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, OK",
  "property_seo_description_reviews": "\"At Liberty Pointe in Oklahoma City, our residents enjoy a lifestyle filled with unparalleled amenities and a vibrant community spirit. From serene poolside lounging and energizing workouts at our fitness center to social gatherings in our clubhouse, there's something for everyone. With thoughtful features like controlled access and a pet washing station, you're not just securing a home—you're enhancing your everyday life. Curious about what makes us special? Dive into our resident reviews and see why Liberty Pointe is the perfect place to call home!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, OK",
  "property_seo_description_applynow": "\"At Liberty Pointe in Oklahoma City, your perfect home awaits! Choose from spacious one, two, or three-bedroom floor plans, all nestled within a vibrant community boasting exceptional amenities. Enjoy relaxing by the pool, staying fit in our state-of-the-art fitness center, or socializing in the inviting clubhouse. With convenient features like key fob entry, door-to-door trash pickup, and 24-hour access, your comfort and convenience are our top priorities. Ready to elevate your lifestyle? Find your new home and lease online today!\"",
  "property_seo_title_residentaccess": "Resident Access | Liberty Pointe",
  "property_seo_description_residentaccess": "\"Welcome back to Liberty Pointe in Oklahoma City! Log in to your resident portal for easy rent payments, hassle-free maintenance requests, and a world of community connections—all at your fingertips. Your convenient lifestyle awaits!\"",
  "property_seo_title_referafriend": "Refer A Friend | Liberty Pointe",
  "property_seo_description_referafriend": "\"At Liberty Pointe in Oklahoma City, friendship and community thrive! Share the joy of our vibrant apartment living by referring a friend today. Together, you'll enjoy exceptional amenities, welcoming spaces, and a lifestyle filled with connection and comfort. Your next great neighbor awaits!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Liberty Pointe",
  "property_seo_description_scheduletour": "Experience the vibrant lifestyle at Liberty Pointe in Oklahoma City, where modern living meets comfort and convenience. A tour of our community awaits you—see for yourself why we’re the perfect place to call home! Schedule your visit today!",
  "property_seo_title_privacy": "Privacy Policy | Liberty Pointe",
  "property_seo_description_privacy": "At Liberty Pointe in Oklahoma City, your privacy is our priority. Uncover how we protect your personal information and ensure a secure community experience. Dive into our comprehensive privacy policy to learn more.",
  "property_seo_title_accessibility": "Website Accessibility | Liberty Pointe",
  "property_seo_description_accessibility": "\"At Liberty Pointe in Oklahoma City, we believe in accessibility for all. Our commitment to digital inclusion ensures that everyone can navigate our community and resources effortlessly. Join us in shaping a more inclusive future — your comfort and convenience are our priorities.\"",
  "property_seo_title_sitemap": "Sitemap | Liberty Pointe",
  "property_seo_description_sitemap": "Navigate your future at Liberty Pointe in Oklahoma City, where modern living meets community charm. Our sitemap is your gateway to explore all that our stunning apartment community has to offer. Uncover amenities, floor plans, and local attractions designed for your lifestyle—find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Liberty Pointe",
  "property_seo_description_thankyou": "Thank you for reaching out to Liberty Pointe in Oklahoma City! Your inquiry is important to us, and our dedicated team will connect with you soon to help you find your ideal apartment in our vibrant community. Stay tuned for personalized insights and exclusive offers tailored just for you!",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293630820",
  "amenities": [
    {
      "id": "ec_c29041b14159665e1d169307",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "Outdoor saltwater pool for residents to enjoy.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74c8f01b1d9e72223864d22c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Game room",
      "amount": "false",
      "description": "Community game room for entertainment and socializing.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b01012616a2bb751a505d603",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "On-site fitness center equipped with cardio machines and weight machines.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6a63d2fe9fd16a37ca40e18",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "Outdoor volleyball court available for resident use.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb863f558f66559caee9ef86",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Barbecue/Grill Area",
      "amount": "false",
      "description": "Designated area with barbecue grills for outdoor cooking.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83fc640bc9019138d6a8069f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Wi-Fi in Clubhouse & Fitness Center",
      "amount": "false",
      "description": "Complimentary Wi-Fi access in the clubhouse and fitness center.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_134acdf573c8ff091d123f82",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Coffee Station",
      "amount": "false",
      "description": "On-site coffee station for residents.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b33372effe07390b91487003",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "Maintenance team available on-site for resident needs.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fddacd1773a8fff5df302b60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "On-site Management",
      "amount": "false",
      "description": "Property management team available on-site.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_174e72507366e828c302f4a3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "Courtesy patrol services for added security.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9063c8113591842625ac0537",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Preferred Employer Discounts",
      "amount": "false",
      "description": "Special discounts available for employees of preferred employers.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e12fe4a108456dea923b9c4f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Active Duty Military Discounts",
      "amount": "false",
      "description": "Discounts offered to active duty military personnel.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75fc46bb7a617a0b2a3efc47",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "Regularly scheduled social activities for residents.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff00b8abf858927c146e4108",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "On-site business center with internet access.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15a2007d44d75e97b33df5c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "Community courtyard for relaxation and socializing.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7984bb86196fc634051a41b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Play Area/ Dog Park",
      "amount": "false",
      "description": "Designated area for pets to play off-leash.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a13482403cba1c48ab57611",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Pond",
      "amount": "false",
      "description": "Scenic pond within the community grounds.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cde91582750f11298234621a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "Outdoor basketball court available for resident use.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28c3d54a460aa469c64bfe32",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Free Weights",
      "amount": "false",
      "description": "Free weights available in the fitness center.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d0a7307c19ebbeba680576a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "Cardio equipment available in the fitness center.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f9ee348a825e8ec289fae69",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Weight Machines",
      "amount": "false",
      "description": "Weight machines available in the fitness center.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31b7761cdc71eb2772647863",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Renters Insurance Program",
      "amount": "false",
      "description": "Program offering renters insurance options.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4493ac4fe5c91c9cc0bd2071",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Walking Trails",
      "amount": "false",
      "description": "Walking trails within the community for exercise and leisure.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4cfdc0b5537386e157b4ec6e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Car Wash Area",
      "amount": "false",
      "description": "Designated area for residents to wash their vehicles.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_acd6ee43e95391ebf673ceaf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Lawn Games Available",
      "amount": "false",
      "description": "Lawn games provided for resident enjoyment.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c77b8225f24838281991201d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "In-unit dishwasher for convenient cleaning.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b847bc1a9d2b755100b6f31d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "Built-in microwave in each apartment.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f36c45e8bb7133582e1da22",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "Appliances designed to conserve energy.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae112218476b10170ce3005f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Ice Maker*",
      "amount": "false",
      "description": "Ice maker included in select units.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6de3de4fe3771b45d2d6b188",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Kitchen Island*",
      "amount": "false",
      "description": "Kitchen island available in select units.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2263363d6235bd12fb8caea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "Pantry space for additional kitchen storage.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e57d102a3f06c84e71dd51c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Central AC and Heating per apartment",
      "amount": "false",
      "description": "Individual central air conditioning and heating systems.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_351f6b9cc4c4baa1c92b0158",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "Air conditioning units in each apartment.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfba4c0079500a9c6f1a7c33",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "Ceiling fans installed in living areas.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a463766a596dc57fcf31dfc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "Private patio or balcony attached to each unit.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40595da2da4287f908636559",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "In-unit washer and dryer for laundry convenience.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6eb642fe1e0661461b92cd86",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Sprinkler System",
      "amount": "false",
      "description": "Fire sprinkler system installed in each apartment.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c899b71b233cbe1db40744c5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "Spacious walk-in closets for ample storage.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c6cf1029f46e4eee8d38e439",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "9 Foot Ceilings",
      "amount": "false",
      "description": "High ceilings to enhance the sense of space.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_403bdf3836b670d978ec98bb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Crown Molding",
      "amount": "false",
      "description": "Decorative crown molding in living areas.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f92d56bc13c59a1005762c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Storage",
      "amount": "false",
      "description": "Additional storage space within the apartment.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e84809a8990e4f987f2171ff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "external_id": "false",
      "title": "Double Vanities*",
      "amount": "false",
      "description": "Double vanity sinks available in select units.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a644d1fc-8e06-4805-bef7-e9299b1453f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-33e1-7118-afc6-0b0268b57d52.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, dark wood cabinets, stainless steel appliances, and an island.",
        "public_id": "01a15663-33e1-7118-afc6-0b0268b57d52",
        "storage_key": "property/6321002732584960/01a15663-33e1-7118-afc6-0b0268b57d52.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Explore this beautifully appointed kitchen, featuring sleek granite countertops, ample dark wood cabinetry, and modern stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, dark wood cabinets, stainless steel appliances, and an island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9f352680-98e2-4696-ae69-d6ee1792079b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-9c72-7428-90fb-7afa5a7d4473.webp",
      "image_media": {
        "alt_text": "Living room with sofa, accent chair, coffee table, and decorative plant.",
        "public_id": "01a15663-9c72-7428-90fb-7afa5a7d4473",
        "storage_key": "property/6321002732584960/01a15663-9c72-7428-90fb-7afa5a7d4473.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, stylish accent chair, and a round ottoman, perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Living room with sofa, accent chair, coffee table, and decorative plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b55305d1-4890-43c7-9dde-12e603345344",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-6e0c-778a-9df3-5bc727b55402.webp",
      "image_media": {
        "alt_text": "Living room and dining area with blue sofa and floral accent chair.",
        "public_id": "01a15663-6e0c-778a-9df3-5bc727b55402",
        "storage_key": "property/6321002732584960/01a15663-6e0c-778a-9df3-5bc727b55402.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable blue sofa, a decorative accent chair, and a formal dining set, perfect for entertaining guests.",
      "link": "",
      "alt_text": "Living room and dining area with blue sofa and floral accent chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_975a2923-fae7-40f1-9683-dba8673ce807",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-3d2d-704c-9888-cd7f3ae76376.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with island and dining table.",
        "public_id": "01a15663-3d2d-704c-9888-cd7f3ae76376",
        "storage_key": "property/6321002732584960/01a15663-3d2d-704c-9888-cd7f3ae76376.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring a large island, dining table, and comfortable seating. Perfect for entertaining and everyday living.",
      "link": "",
      "alt_text": "Living room and kitchen area with island and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6392fbd7-cf82-408d-971b-9ad88857933c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-3517-76ab-9cf1-19957f072502.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in an apartment unit.",
        "public_id": "01a15663-3517-76ab-9cf1-19957f072502",
        "storage_key": "property/6321002732584960/01a15663-3517-76ab-9cf1-19957f072502.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Dine and entertain in style in this open-concept apartment, featuring a spacious dining area adjacent to a modern kitchen.",
      "link": "",
      "alt_text": "Dining area and kitchen in an apartment unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2122dbe6-8211-4285-bf48-9e77b7ace1b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-9897-77be-b2da-e32b4121ed40.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, orange and white bedding, and a dresser.",
        "public_id": "01a15663-9897-77be-b2da-e32b4121ed40",
        "storage_key": "property/6321002732584960/01a15663-9897-77be-b2da-e32b4121ed40.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed with plush bedding, a modern dresser, and a calming ambiance. Your perfect retreat.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, orange and white bedding, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b2c7261c-f18f-4359-ac2c-6f91043b16be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-6d43-7519-9707-0b2cdd110b38.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, dresser, and closet.",
        "public_id": "01a15663-6d43-7519-9707-0b2cdd110b38",
        "storage_key": "property/6321002732584960/01a15663-6d43-7519-9707-0b2cdd110b38.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a comfortable king-sized bed, a spacious dresser with a mirror, and ample closet space for all your storage needs.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed, dresser, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f3997821-2400-4206-aec6-5413ed3c0949",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-782b-7590-86ea-574b71cc79a6.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, closet, and an opening to a living area.",
        "public_id": "01a15663-782b-7590-86ea-574b71cc79a6",
        "storage_key": "property/6321002732584960/01a15663-782b-7590-86ea-574b71cc79a6.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Rest peacefully in this inviting bedroom, complete with a spacious closet and a charming view. Step through to discover the adjacent living area, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Bedroom with a large bed, closet, and an opening to a living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a0140749-6dc9-4150-a093-a10c69aad7a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-9aee-711c-8946-e1d8934334b7.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white shower curtain, bathtub, and toilet.",
        "public_id": "01a15663-9aee-711c-8946-e1d8934334b7",
        "storage_key": "property/6321002732584960/01a15663-9aee-711c-8946-e1d8934334b7.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Relax and unwind in this clean and modern bathroom, featuring a pristine white bathtub and a convenient shower.",
      "link": "",
      "alt_text": "Modern bathroom with white shower curtain, bathtub, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_399556e0-4ab3-4d10-8eb2-64d9dec23320",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-98fe-7715-8972-809570dc498f.webp",
      "image_media": {
        "alt_text": "A bathroom with a shower, toilet, and vanity.",
        "public_id": "01a15663-98fe-7715-8972-809570dc498f",
        "storage_key": "property/6321002732584960/01a15663-98fe-7715-8972-809570dc498f.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Enjoy this clean and modern bathroom, complete with a spacious shower, comfortable toilet, and a sleek vanity with plenty of counter space.",
      "link": "",
      "alt_text": "A bathroom with a shower, toilet, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_105dc901-eee9-42a2-abe7-7ca86f978b45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-8121-70b5-ab98-ee40a836fedc.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, granite countertops, and large mirrors",
        "public_id": "01a15663-8121-70b5-ab98-ee40a836fedc",
        "storage_key": "property/6321002732584960/01a15663-8121-70b5-ab98-ee40a836fedc.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, ample cabinet storage, and large mirrors, perfect for modern living.",
      "link": "",
      "alt_text": "Bathroom with double vanity, granite countertops, and large mirrors",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d2ee5f36-f66c-492b-920e-e5d6d1182b8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-323d-745e-a2c5-ce93be557234.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with shelf above.",
        "public_id": "01a15663-323d-745e-a2c5-ce93be557234",
        "storage_key": "property/6321002732584960/01a15663-323d-745e-a2c5-ce93be557234.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs, with a shelf for extra storage.",
      "link": "",
      "alt_text": "In-unit washer and dryer with shelf above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c88d2aba-eba4-4757-a3c4-0877160b0e27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-356b-7128-8ee0-500e313f7d05.webp",
      "image_media": {
        "alt_text": "Covered patio area with two chairs and a small table.",
        "public_id": "01a15663-356b-7128-8ee0-500e313f7d05",
        "storage_key": "property/6321002732584960/01a15663-356b-7128-8ee0-500e313f7d05.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee on your private patio, perfect for relaxing outdoors.",
      "link": "",
      "alt_text": "Covered patio area with two chairs and a small table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7267a6b0-9bd7-4529-bb30-3ec6da414c13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d99d5-4634-738e-84ab-09ece97df48d.webp",
      "image_media": {
        "alt_text": "Business center with computers and printer in a leasing office.",
        "public_id": "019d99d5-4634-738e-84ab-09ece97df48d",
        "storage_key": "property/6321002732584960/019d99d5-4634-738e-84ab-09ece97df48d.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Utilize our resident business center for all your work and printing needs, featuring computers and a printer.",
      "link": "",
      "alt_text": "Business center with computers and printer in a leasing office.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e2f893e6-3e83-42be-b215-7573ffb4aba5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15668-6373-738e-9bbe-aece5a74e02c.webp",
      "image_media": {
        "alt_text": "Pool table and lounge area with fireplace and TV in community common room.",
        "public_id": "01a15668-6373-738e-9bbe-aece5a74e02c",
        "storage_key": "property/6321002732584960/01a15668-6373-738e-9bbe-aece5a74e02c.webp",
        "width": 800,
        "height": 533
      },
      "title": "Community",
      "description": "Enjoy a game of pool or relax by the fireplace in the community lounge, featuring comfortable seating and entertainment options.",
      "link": "",
      "alt_text": "Pool table and lounge area with fireplace and TV in community common room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d118e275-f56b-4f60-a765-6de0b0367a4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15668-639d-7578-aa12-1a8de810010d.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills and elliptical machines.",
        "public_id": "01a15668-639d-7578-aa12-1a8de810010d",
        "storage_key": "property/6321002732584960/01a15668-639d-7578-aa12-1a8de810010d.webp",
        "width": 800,
        "height": 533
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring state-of-the-art treadmills and elliptical machines for a great workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills and elliptical machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_729ba6e4-2678-4f73-8a33-768b8ea07c1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-6a91-7642-a1b1-99b24d5b416e.webp",
      "image_media": {
        "alt_text": "Outdoor patio with seating, tables, and a grill, overlooking apartments and a grassy courtyard.",
        "public_id": "01a15663-6a91-7642-a1b1-99b24d5b416e",
        "storage_key": "property/6321002732584960/01a15663-6a91-7642-a1b1-99b24d5b416e.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with friends and neighbors at our community's patio, complete with comfortable seating, tables, and a built-in grill. Perfect for al fresco dining and relaxing.",
      "link": "",
      "alt_text": "Outdoor patio with seating, tables, and a grill, overlooking apartments and a grassy courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f1614135-18b0-49c1-956f-69844d1c788b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-6ce8-77cf-8717-01c635fcda0c.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with pergolas and tables near the pool.",
        "public_id": "01a15663-6ce8-77cf-8717-01c635fcda0c",
        "storage_key": "property/6321002732584960/01a15663-6ce8-77cf-8717-01c635fcda0c.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Enjoy our outdoor seating area with pergolas and tables, perfect for relaxing by the pool.",
      "link": "",
      "alt_text": "Outdoor seating area with pergolas and tables near the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c7ca62c8-8b0d-4eb3-aeab-227185b4576d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-69aa-76be-a8f7-d398b42666d7.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with red lounge chairs and a cabana in front of a brick building.",
        "public_id": "01a15663-69aa-76be-a8f7-d398b42666d7",
        "storage_key": "property/6321002732584960/01a15663-69aa-76be-a8f7-d398b42666d7.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Relax by our sparkling outdoor pool, complete with comfortable lounge chairs and shaded cabanas. Enjoy the sunshine and resort-style amenities.",
      "link": "",
      "alt_text": "Outdoor pool area with red lounge chairs and a cabana in front of a brick building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_03341bb1-ec8e-499f-bc60-525034080697",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-6a79-7158-a60f-9b1068b9d39d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a15663-6a79-7158-a60f-9b1068b9d39d",
        "storage_key": "property/6321002732584960/01a15663-6a79-7158-a60f-9b1068b9d39d.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Relax by the resort-style pool with plenty of lounge chairs for sunbathing and adjacent apartment buildings.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d70bec72-38b3-4fa5-9c2e-8e4a4d3d7ee0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-349f-7671-96e3-289e75535c52.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a15663-349f-7671-96e3-289e75535c52",
        "storage_key": "property/6321002732584960/01a15663-349f-7671-96e3-289e75535c52.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable seating. Perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ac1a797-0a68-4bfb-8ac6-aebb457a854b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-3327-77d6-a6f6-e7c91599de01.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and buildings in the background.",
        "public_id": "01a15663-3327-77d6-a6f6-e7c91599de01",
        "storage_key": "property/6321002732584960/01a15663-3327-77d6-a6f6-e7c91599de01.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and beautiful landscaping. Enjoy resort-style living right at your doorstep.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fe808a22-6676-4e94-a6a1-75bb245215fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-3ccf-77ac-89eb-5158c4b3070b.webp",
      "image_media": {
        "alt_text": "Exterior view of the community building with brick facade, arched entrance, and American flag.",
        "public_id": "01a15663-3ccf-77ac-89eb-5158c4b3070b",
        "storage_key": "property/6321002732584960/01a15663-3ccf-77ac-89eb-5158c4b3070b.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "This image showcases the inviting exterior of the community building, featuring a classic brick facade, a grand arched entryway, and a prominent American flag waving in the clear blue sky.",
      "link": "",
      "alt_text": "Exterior view of the community building with brick facade, arched entrance, and American flag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_930ea3d9-481b-4cb2-8779-d1ce746798c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-4763-7280-8d2b-65a64f48c855.webp",
      "image_media": {
        "alt_text": "Exterior building entrance of a multifamily property with brick facade and landscaping.",
        "public_id": "01a15663-4763-7280-8d2b-65a64f48c855",
        "storage_key": "property/6321002732584960/01a15663-4763-7280-8d2b-65a64f48c855.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Welcome home to our beautiful multifamily property, featuring a stunning brick exterior and lush landscaping. Enjoy the community's inviting building entrance.",
      "link": "",
      "alt_text": "Exterior building entrance of a multifamily property with brick facade and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f771cf64-967c-4eef-bb0b-019024acdc89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-33e3-740d-ad40-10497597aebf.webp",
      "image_media": {
        "alt_text": "Entrance to the clubhouse with office hours sign.",
        "public_id": "01a15663-33e3-740d-ad40-10497597aebf",
        "storage_key": "property/6321002732584960/01a15663-33e3-740d-ad40-10497597aebf.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Welcome to the clubhouse, the heart of our community. Office hours are posted for your convenience.",
      "link": "",
      "alt_text": "Entrance to the clubhouse with office hours sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d9d6fcef-9a47-4e8a-8078-439f54c4761b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019f0251-9a1d-760f-85a9-75806186e988.webp",
      "image_media": {
        "alt_text": "Apartment complex with a swimming pool and lounge chairs.",
        "public_id": "019f0251-9a1d-760f-85a9-75806186e988",
        "storage_key": "property/6321002732584960/019f0251-9a1d-760f-85a9-75806186e988.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and spacious grounds at this beautiful apartment community.",
      "link": "",
      "alt_text": "Apartment complex with a swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_70bea183-b827-4dae-8039-9e6e160857a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/01a15663-6da6-734d-9c7f-283c78e2a48d.webp",
      "image_media": {
        "alt_text": "Liberty Pointe monument sign with brick pillars and landscaping.",
        "public_id": "01a15663-6da6-734d-9c7f-283c78e2a48d",
        "storage_key": "property/6321002732584960/01a15663-6da6-734d-9c7f-283c78e2a48d.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Welcome to Liberty Pointe, a premier apartment community. This monument sign features the property name \"Liberty Pointe\" and is surrounded by lush landscaping.",
      "link": "",
      "alt_text": "Liberty Pointe monument sign with brick pillars and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d31cd12f-fe63-405a-b8c4-aff6ee5187ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1109 E Interstate 240 Service Rd, Oklahoma City, OK 73149, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, prime rib, and rolls with cinnamon butter. They also highlight the fast service, friendly staff, and fun atmosphere.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-1faa-77f8-b55a-158c34c37141.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-1faa-77f8-b55a-158c34c37141",
        "storage_key": "property/6321002732584960/019d01a5-1faa-77f8-b55a-158c34c37141.webp",
        "width": 1188,
        "height": 1280
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-south-i-240?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=13128196108413720888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.3922",
      "poi_longitude": "-97.4918158",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-631-8392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-55e3-757d-a698-e689c5b747bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-55e3-757d-a698-e689c5b747bd",
        "storage_key": "property/6321002732584960/019d01a5-55e3-757d-a698-e689c5b747bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_b1ObMVsocROFmq7824MLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_aadb442c-115f-4021-9a0c-1fb18495e868",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "2800 S. Airport Depot Blvd, Midwest City, OK 73110, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Diners say this fast food restaurant serves up delicious chicken fingers with sides of fries, toast, and coleslaw, and they praise the signature Cane's sauce. They also highlight the friendly and efficient service, and the clean dining room.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-1fb6-71b9-8318-6b6aac35b202.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-1fb6-71b9-8318-6b6aac35b202",
        "storage_key": "property/6321002732584960/019d01a5-1fb6-71b9-8318-6b6aac35b202.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/midwest-city/2800-s.-airport-depot-blvd",
      "poi_directions_map_url": "https://maps.google.com/?cid=2861142060269704522&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "35.4364331",
      "poi_longitude": "-97.4054486",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-869-7127",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-55e3-757d-a698-e689c5b747bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-55e3-757d-a698-e689c5b747bd",
        "storage_key": "property/6321002732584960/019d01a5-55e3-757d-a698-e689c5b747bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn4MGqdo9socRShVOeovRtCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_21d0976b-c37c-4972-993f-daf25dac09fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Del Rancho - Midwest City",
      "poi_type": "Restaurants",
      "poi_address": "9201 SE 29th St, Midwest City, OK 73130, USA",
      "poi_short_description": "Casual eatery offering fried chicken, steak sandwiches and steak salads, plus tasty homemade ranch dressing.",
      "poi_long_description": "People say this restaurant serves delicious chicken fried steak sandwiches, steak sandwiches, and onion rings. They highlight the consistently good food and friendly service. They also like the nostalgic decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-9801-7541-8a2c-7625aee29a06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-9801-7541-8a2c-7625aee29a06",
        "storage_key": "property/6321002732584960/019d01a5-9801-7541-8a2c-7625aee29a06.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.delranchousa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14513785092376583495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "del-rancho---midwest-city",
      "poi_latitude": "35.4356294",
      "poi_longitude": "-97.3677358",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-455-5444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-55e3-757d-a698-e689c5b747bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-55e3-757d-a698-e689c5b747bd",
        "storage_key": "property/6321002732584960/019d01a5-55e3-757d-a698-e689c5b747bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGQCqXOo9socRR1136aRSa8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b9caf545-2a92-4612-b826-27eb6cb5410b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Ted's Café Escondido",
      "poi_type": "Restaurants",
      "poi_address": "5301 Main St Suite 117, Del City, OK 73115, USA",
      "poi_short_description": "Local chain serving traditional Mexican fare in a relaxed space with traditional touches.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tortillas, fajitas, and chicken tacos. They also highlight the friendly staff and fast service.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-9747-751f-bce8-be6c2d016dac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-9747-751f-bce8-be6c2d016dac",
        "storage_key": "property/6321002732584960/019d01a5-9747-751f-bce8-be6c2d016dac.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tedscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15938359076429103668&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "teds-caf-escondido",
      "poi_latitude": "35.4436623",
      "poi_longitude": "-97.4247996",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-813-8337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-55e3-757d-a698-e689c5b747bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-55e3-757d-a698-e689c5b747bd",
        "storage_key": "property/6321002732584960/019d01a5-55e3-757d-a698-e689c5b747bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0e3re09socRNAIujSJtMN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_0e70c385-6b97-4bd0-8f2a-ea857e43b5c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5915 SE 15th St, Oklahoma City, OK 73110, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "People say this Italian restaurant serves delicious shrimp scampi, Tour of Italy, and black tie mousse cake. They also highlight the friendly staff, quick service, and convenient location.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-9a6a-7376-af77-c5c76769bc43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-9a6a-7376-af77-c5c76769bc43",
        "storage_key": "property/6321002732584960/019d01a5-9a6a-7376-af77-c5c76769bc43.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ok/oklahoma-city/midwest-city-warren-theater/6451?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:oklahoma-city-ok-6451_pl:locurl_rd:1878",
      "poi_directions_map_url": "https://maps.google.com/?cid=10493755151745627122&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "35.4501389",
      "poi_longitude": "-97.4187144",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-739-8295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-55e3-757d-a698-e689c5b747bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-55e3-757d-a698-e689c5b747bd",
        "storage_key": "property/6321002732584960/019d01a5-55e3-757d-a698-e689c5b747bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8V3WtSA9socR8jO5U7ZOoZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_c9559ae0-87df-4fbe-99ba-4bf21be02235",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1600 S Sooner Rd, Midwest City, OK 73110, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide selection of appliances, plants, flowers, gardening supplies, and DIY supplies. They also highlight the competitive prices, military discount, and easy-to-find items.\n\nOther reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-24d5-742d-aa80-270fe4367d75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-24d5-742d-aa80-270fe4367d75",
        "storage_key": "property/6321002732584960/019d01a5-24d5-742d-aa80-270fe4367d75.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Midwest-City/OK/Midwest-City/73110/3911?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9008140853522706823&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.4489526",
      "poi_longitude": "-97.421613",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-737-3410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-55e6-75ea-848b-21cdc23beede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-55e6-75ea-848b-21cdc23beede",
        "storage_key": "property/6321002732584960/019d01a5-55e6-75ea-848b-21cdc23beede.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJR8EKFJM9socRh7HnDGFYA30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_a315e4c0-25a6-40fc-b52a-0f021ad30b7b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "7151 SE 29th St, Midwest City, OK 73110, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide selection of products. They also highlight the friendly and helpful staff, and the well-organized layout.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-26d9-7494-9f3b-375af8644cce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-26d9-7494-9f3b-375af8644cce",
        "storage_key": "property/6321002732584960/019d01a5-26d9-7494-9f3b-375af8644cce.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Midwest-City/2574?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2574-_-na-_-0-_-0&y_source=1_MTE4MzI1Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8778003851890382310&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.4371015",
      "poi_longitude": "-97.4027692",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-869-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-55e6-75ea-848b-21cdc23beede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-55e6-75ea-848b-21cdc23beede",
        "storage_key": "property/6321002732584960/019d01a5-55e6-75ea-848b-21cdc23beede.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJRaE-OtA9socR5tXv1P670Xk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_49f33764-4c65-4913-bc2f-01c870244e2f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7601 E Reno Ave, Midwest City, OK 73110, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of products, including fresh produce, meat, and bulk foods. They highlight the great prices and value, and the clean and well-organized store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-2948-7299-bf30-a967bc0dc55a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-2948-7299-bf30-a967bc0dc55a",
        "storage_key": "property/6321002732584960/019d01a5-2948-7299-bf30-a967bc0dc55a.webp",
        "width": 1280,
        "height": 670
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16993619976886866437&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "35.4652235",
      "poi_longitude": "-97.3915018",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-233-3252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-55df-7594-877f-69edcd311c4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-55df-7594-877f-69edcd311c4c",
        "storage_key": "property/6321002732584960/019d01a5-55df-7594-877f-69edcd311c4c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL5WniFM8socRBdJSOlV31es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_6ce406fa-f24f-48f0-9881-82e98eff1bfe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Rose State College",
      "poi_type": "Education",
      "poi_address": "6420 SE 15th St, Midwest City, OK 73110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-9cdf-7699-ae13-a01141932406.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-9cdf-7699-ae13-a01141932406",
        "storage_key": "property/6321002732584960/019d01a5-9cdf-7699-ae13-a01141932406.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.rose.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16920593240303172125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-state-college",
      "poi_latitude": "35.4446054",
      "poi_longitude": "-97.4137767",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-733-7673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-55db-73dc-bfae-1dc63a633c1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-55db-73dc-bfae-1dc63a633c1a",
        "storage_key": "property/6321002732584960/019d01a5-55db-73dc-bfae-1dc63a633c1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW2H9qcE9socRHXolJecF0uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c179dbbe-12c9-4c72-82a6-53be3d4f18e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Pioneer Library System - Moore Public Library",
      "poi_type": "Education",
      "poi_address": "225 S Howard Ave, Moore, OK 73160, USA",
      "poi_short_description": "Local institution that provides books, DVDs, computers and programs, with an emphasis on children's offerings.",
      "poi_long_description": "People say this library offers a good selection of books and other materials, and has a large area for children to explore, play, and learn. They highlight the library hosts engaging weekly programs for kids and has a photo booth, and the staff are helpful and kind. They also like the clean and well-kept facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-9ee6-7189-866c-b0f08933bd5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-9ee6-7189-866c-b0f08933bd5f",
        "storage_key": "property/6321002732584960/019d01a5-9ee6-7189-866c-b0f08933bd5f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://pioneerlibrarysystem.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13566280005030728682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pioneer-library-system---moore-public-library",
      "poi_latitude": "35.3358205",
      "poi_longitude": "-97.4885841",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-793-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-f510d3ffae9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-f510d3ffae9e",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-f510d3ffae9e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0xg3BdMUsocR6lNXj8kbRbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_cbbdc1df-c6c8-4c57-91f8-5b8f74ecc041",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Christian Heritage Academy",
      "poi_type": "Education",
      "poi_address": "4400 SE 27th St, Del City, OK 73115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-a096-771f-9cbb-424c0acf01d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-a096-771f-9cbb-424c0acf01d7",
        "storage_key": "property/6321002732584960/019d01a5-a096-771f-9cbb-424c0acf01d7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://cha.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10113757647911313450&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "christian-heritage-academy",
      "poi_latitude": "35.436904",
      "poi_longitude": "-97.4396806",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-672-1787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-55db-73dc-bfae-1dc63a633c1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-55db-73dc-bfae-1dc63a633c1a",
        "storage_key": "property/6321002732584960/019d01a5-55db-73dc-bfae-1dc63a633c1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_wqRZR0WsocRKuAk7P5IW4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d2d15177-bc29-4be8-8487-0d8e9cffd57e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Midwest City Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "8143 E Reno Ave, Oklahoma City, OK 73110, USA",
      "poi_short_description": "Public library offering books, computers, and educational games, plus after-school art programs.",
      "poi_long_description": "People say this public library offers a wide selection of books and resources, including access to computers and printing services. They highlight the helpful and accommodating staff, and the availability of study spaces and an art gallery. They also like the fun events offered monthly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-a097-778a-b642-21461fdee0b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-a097-778a-b642-21461fdee0b9",
        "storage_key": "property/6321002732584960/019d01a5-a097-778a-b642-21461fdee0b9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6623002516285178004&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "midwest-city-library---metropolitan-library-system",
      "poi_latitude": "35.465869",
      "poi_longitude": "-97.385387",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-732-4828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-55db-73dc-bfae-1dc63a633c1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-55db-73dc-bfae-1dc63a633c1a",
        "storage_key": "property/6321002732584960/019d01a5-55db-73dc-bfae-1dc63a633c1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ39iO6FA8socRlECyybKh6Vs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_0291b668-29dd-4a5d-8542-3bb511978d5b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Museum of Osteology",
      "poi_type": "Entertainment",
      "poi_address": "10301 S Sunnylane Rd, Oklahoma City, OK 73160, USA",
      "poi_short_description": "Unique spot for educational exhibits of 300+ skeletons of many species plus hands-on displays.",
      "poi_long_description": "People say this museum offers a fascinating collection of real skeletons and skulls, with many displays being interactive and touchable. They highlight the informative and visually appealing exhibits, and the fun scavenger hunts for all ages. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-a230-770a-9627-e57abdf1f4ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-a230-770a-9627-e57abdf1f4ff",
        "storage_key": "property/6321002732584960/019d01a5-a230-770a-9627-e57abdf1f4ff.webp",
        "width": 500,
        "height": 500
      },
      "poi_business_url": "http://www.skeletonmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9091622308725140297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "museum-of-osteology",
      "poi_latitude": "35.3648349",
      "poi_longitude": "-97.4418414",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-814-0006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-f80e27c7db78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-f80e27c7db78",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-f80e27c7db78.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ57ahxGMVsocRSSuU_1HuK34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_fcbfa2a9-cb30-4864-895b-9e143c3ba76f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "First Americans Museum",
      "poi_type": "Entertainment",
      "poi_address": "659 First Americans Blvd, Oklahoma City, OK 73129, USA",
      "poi_short_description": "",
      "poi_long_description": "Visitors say this museum offers a wealth of information about Native American history and culture through engaging exhibits, videos, and artifacts. They also highlight the museum's beautiful architecture and friendly, knowledgeable staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.famok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1363703120278945108&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "first-americans-museum",
      "poi_latitude": "35.4580352",
      "poi_longitude": "-97.4820974",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-594-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-f80e27c7db78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-f80e27c7db78",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-f80e27c7db78.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB4b90oEXsocRVH1RP8PY7BI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2d6e8de4-e9a8-4a4b-be6a-373002ba6ed7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Altitude 1291",
      "poi_type": "Entertainment",
      "poi_address": "6235 SE 15th St, Midwest City, OK 73110, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a wide variety of games, including classic arcade favorites, newer games, bowling, laser tag, and rock climbing. They also highlight the fun and lively atmosphere, and the friendly and helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-a43f-7528-a5f3-04d4905482d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-a43f-7528-a5f3-04d4905482d7",
        "storage_key": "property/6321002732584960/019d01a5-a43f-7528-a5f3-04d4905482d7.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.altitude1291.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2086259566222150947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "altitude-1291",
      "poi_latitude": "35.451479",
      "poi_longitude": "-97.4154483",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-455-8386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQk-7Mg9socRI43uoQXi8xw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_0a0372a5-284b-4f80-8a58-04e2f05a2434",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Midwest City High School Football Stadium",
      "poi_type": "Entertainment",
      "poi_address": "701 E Lockheed Dr, Midwest City, OK 73110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17038004533191603402&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "midwest-city-high-school-football-stadium",
      "poi_latitude": "35.4429538",
      "poi_longitude": "-97.4006941",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5aac-75a0-9dd9-66d03336daf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5aac-75a0-9dd9-66d03336daf6",
        "storage_key": "property/6321002732584960/019d01a5-5aac-75a0-9dd9-66d03336daf6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLT2O5cs9socRynRhCtomc-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_5e3d7042-8ae7-4c29-9607-a72f0b90987f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Carl Albert Titans Football Field",
      "poi_type": "Entertainment",
      "poi_address": "2515 S Post Rd, Midwest City, OK 73130, USA",
      "poi_short_description": "Venue used for softball games that's suitable for children.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://stadiumconnection.com/ok/stadium.php?id=2513",
      "poi_directions_map_url": "https://maps.google.com/?cid=1748220841108324382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "carl-albert-titans-football-field",
      "poi_latitude": "35.4401032",
      "poi_longitude": "-97.3561675",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5aac-75a0-9dd9-66d03336daf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5aac-75a0-9dd9-66d03336daf6",
        "storage_key": "property/6321002732584960/019d01a5-5aac-75a0-9dd9-66d03336daf6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd502hxk9socRHkAyr5ftQhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_7644064f-f56c-449f-9e8e-7fdaf09202d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5701 E Reno Ave # B, Midwest City, OK 73110, USA",
      "poi_short_description": "Gym with a relaxed atmosphere providing a variety of equipment and tanning beds, plus massage facilities.",
      "poi_long_description": "People say this gym offers a wide selection of equipment, including free weights and machines, and has clean bathrooms with showers and drying stalls. They highlight the affordable membership options and convenient locations, as well as the friendly and helpful staff. They also like the peaceful and judgment-free atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-a68d-711a-9876-01f515d31e8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-a68d-711a-9876-01f515d31e8a",
        "storage_key": "property/6321002732584960/019d01a5-a68d-711a-9876-01f515d31e8a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/midwest-city-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1970024258771176692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.465461",
      "poi_longitude": "-97.4227218",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-458-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs90YVpw9socR9Ez1LqDuVhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_69421ef6-675a-427d-b709-66a8ce3e6e3f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "711 S Air Depot Blvd, Midwest City, OK 73110, USA",
      "poi_short_description": "Gym known for a range of workout styles, plus trainers and friendly service.",
      "poi_long_description": "Gym goers say this gym offers a variety of equipment, a sauna, and 24/7 access. They also highlight the friendly and helpful staff, and the clean facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-3687-7319-83df-e38c7ec9b7bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-3687-7319-83df-e38c7ec9b7bb",
        "storage_key": "property/6321002732584960/019d01a5-3687-7319-83df-e38c7ec9b7bb.webp",
        "width": 606,
        "height": 341
      },
      "poi_business_url": "https://10gym.com/midwest-city-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15973367468543869624&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "35.4574211",
      "poi_longitude": "-97.4074666",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-737-8441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo7_-6ro9socRuIJWBRXNrN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f3efd653-aa61-493f-b09b-a8f038507d85",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Tinker Bldg 216 Fitness Annex",
      "poi_type": "Health and Wellness",
      "poi_address": "Bldg 216, Arnold St, Tinker Air Force Base, OK 73145, USA",
      "poi_short_description": "Clean, old-school facility featuring treadmills as well as free weights and racquetball.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-a756-76b4-aa61-6da841dd3a4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-a756-76b4-aa61-6da841dd3a4d",
        "storage_key": "property/6321002732584960/019d01a5-a756-76b4-aa61-6da841dd3a4d.webp",
        "width": 1280,
        "height": 1234
      },
      "poi_business_url": "https://tinkerliving.com/fitness-sports-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6898054950916480281&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tinker-bldg-216-fitness-annex",
      "poi_latitude": "35.4285525",
      "poi_longitude": "-97.3955895",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-734-2163",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoXmIPXA9socRGV2ALm7Qul8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fbb76d0e-f3a3-4ed7-880b-3d6d03e3359d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Gerrity Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "5109 McNarney Ave, Tinker Air Force Base, OK 73145, USA",
      "poi_short_description": "Free gym with cardio and weight equipment, plus a sauna, basketball court, and volleyball court.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-a904-726c-bdbb-ef2b6e12a6a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-a904-726c-bdbb-ef2b6e12a6a6",
        "storage_key": "property/6321002732584960/019d01a5-a904-726c-bdbb-ef2b6e12a6a6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tinkerliving.com/fitness-sports-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15744251277223169163&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gerrity-gym",
      "poi_latitude": "35.428775",
      "poi_longitude": "-97.4178921",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-734-5607",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ78JJ8uA9socRi4xguR7Rfto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7efaa546-8a11-4c0c-a08c-7319bd82211e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Rep Republic",
      "poi_type": "Health and Wellness",
      "poi_address": "4721 SE 15th St, Del City, OK 73115, USA",
      "poi_short_description": "Members-only gym offering equipment made in the USA, a posing room, and a businesslike atmosphere.",
      "poi_long_description": "People say this gym offers a wide variety of high-quality equipment and protein drinks. They highlight the clean and organized environment, and the motivating and uplifting atmosphere. They also like the friendly, welcoming, and encouraging staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-ab9d-727f-b157-a29e3ea9b347.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-ab9d-727f-b157-a29e3ea9b347",
        "storage_key": "property/6321002732584960/019d01a5-ab9d-727f-b157-a29e3ea9b347.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.reprepublicgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=207150140087190705&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rep-republic",
      "poi_latitude": "35.4505808",
      "poi_longitude": "-97.4294632",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-900-5315",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyeOIbtY9socRscQRc_Tx3wI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1114f24b-e130-4443-9985-dc128a7e3073",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Wynn Nails & Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "5501 Main St Suite 107, Del City, OK 73115, USA",
      "poi_short_description": "Relaxed option for mani-pedis, acrylics and other nail services, plus waxing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-3f14-761e-8510-198f801da679.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-3f14-761e-8510-198f801da679",
        "storage_key": "property/6321002732584960/019d01a5-3f14-761e-8510-198f801da679.webp",
        "width": 943,
        "height": 319
      },
      "poi_business_url": "https://wynnnailofdelcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8162211791455041663&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wynn-nails--spa",
      "poi_latitude": "35.441763",
      "poi_longitude": "-97.4241928",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-225-7340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZf4nmY9socRf7guC2EARnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_d9c5f9c0-434e-4c28-804b-ed8d3e484151",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Pearl Nails & Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "5101 SE 29th St Suite 101, Del City, OK 73115, USA",
      "poi_short_description": "Nail salon offering a range of services, including pedicures, in a clean and elegant setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-aca3-73ad-a3e7-250fa8309f41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-aca3-73ad-a3e7-250fa8309f41",
        "storage_key": "property/6321002732584960/019d01a5-aca3-73ad-a3e7-250fa8309f41.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://pearlnailsspaok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1556905988391369338&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pearl-nails--spa",
      "poi_latitude": "35.4358723",
      "poi_longitude": "-97.4262634",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-900-6556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOyc0jXQ9socRevq-Yr89mxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_08a70366-a471-4023-8877-33f220b2541b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "5904 SE 15th St, Midwest City, OK 73110, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-ad13-729c-be1e-a64859a9474b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-ad13-729c-be1e-a64859a9474b",
        "storage_key": "property/6321002732584960/019d01a5-ad13-729c-be1e-a64859a9474b.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/ok/midwest-city/5904-se-15th-st",
      "poi_directions_map_url": "https://maps.google.com/?cid=9291579573008419531&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "35.4494205",
      "poi_longitude": "-97.4189677",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-610-6015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2aJEM09socRy0pxi2RS8oA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_c827348b-b6c2-4cd1-ba84-42cef84bcbd1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Silver Leaf Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "530 N Eastern Ave, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-ae24-7456-8329-a198b6c37504.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-ae24-7456-8329-a198b6c37504",
        "storage_key": "property/6321002732584960/019d01a5-ae24-7456-8329-a198b6c37504.webp",
        "width": 1172,
        "height": 1280
      },
      "poi_business_url": "http://www.silverleafvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12122211313649812818&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "silver-leaf-animal-hospital",
      "poi_latitude": "35.3434627",
      "poi_longitude": "-97.4764585",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-794-7771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_2Gl2SgVsocRUoVRqva-Oqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_e965f3c2-b062-4ff8-a806-eca015371665",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Reno Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6400 E Reno Ave, Midwest City, OK 73110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-b031-742c-9860-d20889c021ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-b031-742c-9860-d20889c021ea",
        "storage_key": "property/6321002732584960/019d01a5-b031-742c-9860-d20889c021ea.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://renoanimalhospital.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11765368419171961972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "reno-animal-hospital",
      "poi_latitude": "35.463615",
      "poi_longitude": "-97.414011",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-733-3346",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQOYK6I9socRdAxY3D38RqM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_f94f7281-1f6e-44df-bc17-84d7121a660c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Oklahoma Heart Hospital South",
      "poi_type": "Health and Wellness",
      "poi_address": "5200 E Interstate 240 Service Rd, Oklahoma City, OK 73135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-b11f-746c-8c1a-db75d3eba22c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-b11f-746c-8c1a-db75d3eba22c",
        "storage_key": "property/6321002732584960/019d01a5-b11f-746c-8c1a-db75d3eba22c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okheart.com/locations/oklahoma-heart-hospital-south",
      "poi_directions_map_url": "https://maps.google.com/?cid=10526556053115636738&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-heart-hospital-south",
      "poi_latitude": "35.3895427",
      "poi_longitude": "-97.4267341",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-628-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5c85-72e8-9997-7d73e57cf7c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5c85-72e8-9997-7d73e57cf7c5",
        "storage_key": "property/6321002732584960/019d01a5-5c85-72e8-9997-7d73e57cf7c5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE67KjocVsocRAgwyTvXWFZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c2d2d2b7-1cd5-46fb-aed1-726843a05552",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "SSM Health St. Anthony Hospital - Midwest",
      "poi_type": "Health and Wellness",
      "poi_address": "2825 Parklawn Dr, Midwest City, OK 73110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-44d5-763d-8ea5-d62229dbc98d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-44d5-763d-8ea5-d62229dbc98d",
        "storage_key": "property/6321002732584960/019d01a5-44d5-763d-8ea5-d62229dbc98d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ssmhealth.com/locations/st-anthony-hospital-midwest?utm_id=sys-listings-1&linksource=sys_listing_links-gmb_listing&y_source=1_MjM0MjQ2ODQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6221024509400691526&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ssm-health-st-anthony-hospital---midwest",
      "poi_latitude": "35.4668521",
      "poi_longitude": "-97.3939461",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-610-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5c85-72e8-9997-7d73e57cf7c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5c85-72e8-9997-7d73e57cf7c5",
        "storage_key": "property/6321002732584960/019d01a5-5c85-72e8-9997-7d73e57cf7c5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJS2zV3FQ8socRRrPTtdSEVVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_66b77c11-ac2f-447a-a0eb-6b43dbd2d1ca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Buck Thomas Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1903 NE 12th St, Moore, OK 73160, USA",
      "poi_short_description": "Expansive, nearly 130-acre park featuring a playground, fishing, a walking trail & more.",
      "poi_long_description": "People say this park offers baseball fields, playgrounds, walking trails, and a dog park with separate areas for small and large dogs. They highlight the easy access, ample parking, and covered bleachers for spectators. They also like the family-friendly atmosphere and the availability of food trucks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-b2ef-7159-8f50-5be58c00f55a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-b2ef-7159-8f50-5be58c00f55a",
        "storage_key": "property/6321002732584960/019d01a5-b2ef-7159-8f50-5be58c00f55a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/buck-thomas-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13701592146103086508&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "buck-thomas-park",
      "poi_latitude": "35.3524633",
      "poi_longitude": "-97.4668896",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-793-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5c94-7179-8e62-c47bab3706e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5c94-7179-8e62-c47bab3706e1",
        "storage_key": "property/6321002732584960/019d01a5-5c94-7179-8e62-c47bab3706e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB31aBTwVsocRrK3BdXbVJb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_da4fa352-cc1a-4378-8a56-3198427bba0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Trosper Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2301 SE 29th St, Oklahoma City, OK 73129, USA",
      "poi_short_description": "Heavily wooded 18-hole municipal golf course with a small creek plus instruction & practice greens.",
      "poi_long_description": "Heavily wooded 18-hole municipal golf course with a small creek plus instruction & practice greens.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.okcgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13701287864837489120&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trosper-golf-course",
      "poi_latitude": "35.43541",
      "poi_longitude": "-97.471357",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-677-8874",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5c95-7185-8b24-8c54f95a50b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5c95-7185-8b24-8c54f95a50b8",
        "storage_key": "property/6321002732584960/019d01a5-5c95-7185-8b24-8c54f95a50b8.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJkacCD2UWsocR4EECdbjAJL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_a60cdbf7-00d2-42a7-bd0c-c759f6926b30",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Del City Ball Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1900 S Sunnylane Rd, Oklahoma City, OK 73115, USA",
      "poi_short_description": "Sports complex with 12 fields hosting youth baseball & softball leagues & weekend tournaments.",
      "poi_long_description": "People say this park offers great baseball fields and enjoyable cheeseburgers.\n\nOther reviews mention the parking can be difficult and the facilities can be run down.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-b51f-763e-b3e2-a3bc7cc0a5bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-b51f-763e-b3e2-a3bc7cc0a5bc",
        "storage_key": "property/6321002732584960/019d01a5-b51f-763e-b3e2-a3bc7cc0a5bc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.delcityballpark.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13033152723359909048&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "del-city-ball-park",
      "poi_latitude": "35.4468545",
      "poi_longitude": "-97.4374387",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-672-5055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5c94-7179-8e62-c47bab3706e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5c94-7179-8e62-c47bab3706e1",
        "storage_key": "property/6321002732584960/019d01a5-5c94-7179-8e62-c47bab3706e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJp4FOdx8WsocRuERIa1kP37Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_30c4859e-9e99-46ae-b94a-df80c31ad220",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Joe B. Barnes Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8700 E Reno Ave, Midwest City, OK 73130, USA",
      "poi_short_description": "Water- and wildlife-filled, family-friendly park, with picnic tables, sports fields and walking trails.",
      "poi_long_description": "People say this park offers a variety of amenities, including playgrounds, walking trails, picnic areas, and a dog park. They highlight the spaciousness, the unique castle structures, and the fun activities for children. They also like the free entry and the opportunity to make a donation.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.midwestcityok.org/parksrec/page/joe-b-barnes-regional-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12346391283087338729&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "joe-b-barnes-regional-park",
      "poi_latitude": "35.462858",
      "poi_longitude": "-97.3757281",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-739-1293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5c94-7179-8e62-c47bab3706e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5c94-7179-8e62-c47bab3706e1",
        "storage_key": "property/6321002732584960/019d01a5-5c94-7179-8e62-c47bab3706e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW1MhekQ8socR6WxmPnUxV6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_62ff2338-c015-45d4-905e-bbda20d95aaf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "John Conrad Regional Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "711 S Douglas Blvd, Midwest City, OK 73130, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this golf course has challenging greens and fairways in fantastic shape. They also highlight the well-maintained course, new carts, and fully stocked pro shop.\n\nOther reviews mention the staff can be unorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-b58d-723c-a536-a2439adebff7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-b58d-723c-a536-a2439adebff7",
        "storage_key": "property/6321002732584960/019d01a5-b58d-723c-a536-a2439adebff7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.midwestcityok.org/parksrec/page/john-conrad-regional-golf-course",
      "poi_directions_map_url": "https://maps.google.com/?cid=10195593286126610213&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "john-conrad-regional-golf-course",
      "poi_latitude": "35.4573471",
      "poi_longitude": "-97.3728539",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-732-2209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5c95-7185-8b24-8c54f95a50b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5c95-7185-8b24-8c54f95a50b8",
        "storage_key": "property/6321002732584960/019d01a5-5c95-7185-8b24-8c54f95a50b8.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJTyB8VGg8socRJSfvPRMGfo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_3c2b902b-314d-4a66-857d-b266d0e2525e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "VQ-3 And VQ-4",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7817-7899 SE 60th St, Oklahoma City, OK 73145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2001918452257240090&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vq-3-and-vq-4",
      "poi_latitude": "35.4038112",
      "poi_longitude": "-97.3920759",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLRX04vQ-socRGrQXyDk-yBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a90e07c3-83fe-4219-8829-52498e954c79",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "EMSA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6205 S Sooner Rd, Oklahoma City, OK 73135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-b66d-75c6-8dc3-09a7ca48c15c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-b66d-75c6-8dc3-09a7ca48c15c",
        "storage_key": "property/6321002732584960/019d01a5-b66d-75c6-8dc3-09a7ca48c15c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://emsaok.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11533109690373406475&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "emsa",
      "poi_latitude": "35.4034694",
      "poi_longitude": "-97.4247848",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-297-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1VXjmk8_socRC39SiijWDaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_dd1b3e96-3d9b-45bf-80e2-c678997bf9fa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Balon Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3245 S Hattie Ave, Oklahoma City, OK 73129, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-b775-73c9-8a38-a8f6756d066b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a5-b775-73c9-8a38-a8f6756d066b",
        "storage_key": "property/6321002732584960/019d01a5-b775-73c9-8a38-a8f6756d066b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.balon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3475131748365701705&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "balon-corporation",
      "poi_latitude": "35.4316418",
      "poi_longitude": "-97.4884057",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-677-3321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQubgo8WsocRSRIFweklOjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fccc7435-858c-492d-9c53-0df08cf42382",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "Tinker AFB CAC/ID Card Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Arnold St Bldg 1, Tinker Air Force Base, OK 73145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=70169305400851678&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tinker-afb-cacid-card-office",
      "poi_latitude": "35.4308276",
      "poi_longitude": "-97.3928103",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-739-7646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn7GVQ8Y9socR3ryNipxK-QA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8b1ad1c5-451a-40b9-8cc5-bec811ce29d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "poi_name": "The Boeing Company BLDG 84-133",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6001 S Air Depot Blvd, Oklahoma City, OK 73135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10838506082843357847&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-boeing-company-bldg-84-133",
      "poi_latitude": "35.4048998",
      "poi_longitude": "-97.4073421",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a5-5954-74ce-bd44-fd835345c829",
        "storage_key": "property/6321002732584960/019d01a5-5954-74ce-bd44-fd835345c829.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-V5I2g-socRl_LJg9sbapY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_06ce1ba4b4f5d58be9f4268d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_61f604c089de017764f1a179",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_1b8fa35295c6c8695dc4761c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "day": "WED",
      "open_time": "10:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_aac07c4ac0e0072fdac3b40d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c167f03430f3f28c3ba85a5f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c86ee65903e6a8488b4c8ae4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_fa859025-a5e0-4f7e-a508-9f749b299bc9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "rating": "5.0",
      "name": "Maquel Chapman",
      "text": "Kenny and Chris are amazing! Such a great help! I recently put in a work order for the bathroom. After taking care of the issue, he mentioned the dryer vent outside the building looked like it needed to be cleared and asked if it was okay to check on my dryer as well. Every time I put in a request, they are always so efficient, so polite and so thorough. I really appreciate how professional and friendly they are. Super grateful for them and all they do!",
      "date": "2025-11-03",
      "title": ""
    },
    {
      "id": "custom_17e6a74c-6be1-446a-9860-d6e44bedd0c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "rating": "5.0",
      "name": "Jonathan Fernandez",
      "text": "I just moved into a new unit at Liberty Pointe, and Orlando was excellent throughout the whole process. He made everything super easy and stress-free. Whenever I had a question, he got back to me right away and ensured everything was ready before I moved in. The entire transition went remarkably smoothly, and it couldn’t have gone better. Really appreciate his help and how easy he made everything. Thanks again, Orlando!",
      "date": "2025-10-31",
      "title": ""
    },
    {
      "id": "custom_7b8562ae-81a4-40cc-8053-02791da3fcea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "rating": "5.0",
      "name": "Sue Clark",
      "text": "We have been living here at Liberty Pointe since 2016! Over the years, office & maintenance staff have changed but the service never does. They ALL are so very accommodating and willing to take care of their residents. We truly appreciate and are very grateful to live in this community!",
      "date": "2025-10-27",
      "title": ""
    },
    {
      "id": "custom_637dce6e-0a8a-4f31-9ada-b409edee09fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "rating": "5.0",
      "name": "Aubrey Shae",
      "text": "I can’t say enough good things about Orlando! He went above and beyond to make my move-in process smooth and stress-free. He was professional, friendly, and made sure I had everything I needed to feel comfortable in my new apartment. Orlando explained everything clearly, answered all of my questions with patience, and was incredibly helpful throughout the entire process. Moving can be overwhelming, but he made it such a positive experience. I’m so grateful for his help!",
      "date": "2025-09-29",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_3a57d859-0b8b-4d2a-8445-e0b7d37f50ca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a6-49b5-71d6-aa98-a9d53ee63b16.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with granite island and stainless steel appliances.",
        "public_id": "019d01a6-49b5-71d6-aa98-a9d53ee63b16",
        "storage_key": "property/6321002732584960/019d01a6-49b5-71d6-aa98-a9d53ee63b16.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Weidner Apartment Homes - Liberty Pointe - Capitol Suite C1 | 3x2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=g8bKHtjG7y9"
    },
    {
      "id": "custom_0c3e99d3-36fb-4137-bee9-b7aea4a2c9cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a6-49bb-77ff-81fb-3a522ab7a9aa.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living room with carpet, blinds on window, and ceiling fan.",
        "public_id": "019d01a6-49bb-77ff-81fb-3a522ab7a9aa",
        "storage_key": "property/6321002732584960/019d01a6-49bb-77ff-81fb-3a522ab7a9aa.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Weidner Apartment Homes - Liberty Pointe - Rushmore A3 | 1x1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=EFVSzihbALS"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-2671-75ca-9717-8e906a5159a6",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "liberty-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960"
    },
    {
      "lead_collector_id": "0198aa47-26d2-73ae-a69f-bb4b2774af53",
      "lead_source": "FACEBOOK_ADS",
      "name": "liberty-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960"
    },
    {
      "lead_collector_id": "0198aa47-2735-75b8-9c26-3b9752e1ebe6",
      "lead_source": "LANDING_PAGE",
      "name": "liberty-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "page_item_url": "luxury-apartments-pool-oklahoma-city",
      "search_query": "luxury apartments with pool Oklahoma City",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in OKC",
      "h2_subtitle": "Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.",
      "page_copy": "Discover Liberty Pointe, where luxury meets comfort in Oklahoma City. Our community offers luxurious apartments with a pool, letting you unwind and socialize with ease. Choose from spacious floor plans, including one, two, and three-bedroom options, tailored to fit your lifestyle. Whether you're lounging by our sparkling swimming pool or staying active at our modern fitness center, relaxation and recreation are at your doorstep.\n\nJoin a vibrant community at Liberty Pointe, where social events and serene surroundings add to the allure. Perfectly located in the Kennington-Ridgefield neighborhood, our apartments offer exceptional amenities such as a car wash area, grill, and sundeck. Experience the best of luxury apartments with pool amenities in Oklahoma City, and make Liberty Pointe your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and black appliances.",
        "public_id": "019d01a5-0ee3-710f-9412-a7df65ffb9ab",
        "storage_key": "property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Oklahoma City",
      "seo_description": "Discover luxury living with a pool at Liberty Pointe in Oklahoma City. Enjoy spacious floor plans and top amenities. Your perfect home awaits!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-kennington-ridgefield-ok",
      "search_query": "apartments with fitness center in Kennington-Ridgefield OK",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in OK",
      "h2_subtitle": "Find the perfect apartment with a fitness center at Liberty Pointe in Kennington-Ridgefield, OK. Experience an active lifestyle today.",
      "page_copy": "Welcome to Liberty Pointe, a premier choice for those seeking apartments with a fitness center in Kennington-Ridgefield, OK. Our exceptional community is dedicated to promoting health and wellness with modern amenities that suit an active lifestyle. Choose from spacious one, two, or three-bedroom floor plans and enjoy immediate access to a well-equipped fitness center designed to help you achieve your fitness goals.\n\nAlong with a state-of-the-art gym, Liberty Pointe offers luxurious features such as a sparkling pool, sundeck, and a serene courtyard perfect for unwinding after a workout. Located in the heart of Kennington-Ridgefield, our community offers convenient access to local attractions and services. Embrace the vibrant lifestyle that Liberty Pointe has to offer, and start making fitness a natural part of your routine in the comfort of our welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and black appliances.",
        "public_id": "019d01a5-0ee3-710f-9412-a7df65ffb9ab",
        "storage_key": "property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in OK",
      "seo_description": "Discover Kennington-Ridgefield's Liberty Pointe, featuring a modern fitness center and luxury living. Choose your ideal apartment today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-dog-park-okc",
      "search_query": "dog friendly apartments with dog park OKC",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments with Park in OKC",
      "h2_subtitle": "Enjoy dog-friendly living at Liberty Pointe in Oklahoma City. Our community features a dog park ideal for pet owners in OKC.",
      "page_copy": "Liberty Pointe in Oklahoma City is the perfect destination for pet owners seeking dog-friendly apartments with a dog park. Our community understands the needs of pet lovers and provides ample amenities to ensure both you and your furry friends feel at home. Featuring spacious one, two, or three-bedroom floor plans, our apartments are designed for comfort and luxury, ensuring an ideal living environment.\n\nJoin a thriving community in the Kennington-Ridgefield neighborhood, where pets are warmly welcomed. Enjoy the convenience of our on-site dog park, as well as other luxurious amenities such as a pool and fitness center. With our stunning surroundings and pet-friendly approach, Liberty Pointe is the perfect place for both you and your dog to thrive. Experience the best of dog-friendly living in OKC today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and black appliances.",
        "public_id": "019d01a5-0ee3-710f-9412-a7df65ffb9ab",
        "storage_key": "property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments with Park in OKC",
      "seo_description": "Discover Liberty Pointe in OKC, where dog-friendly apartments meet comfort and convenience with a dog park for pet owners.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-oklahoma-city-ok",
      "search_query": "in-unit laundry apartments Oklahoma City OK",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in OKC, OK",
      "h2_subtitle": "Discover the convenience of in-unit laundry at Liberty Pointe in Oklahoma City, OK. Enjoy modern amenities in a comfortable setting.",
      "page_copy": "At Liberty Pointe in Oklahoma City, OK, we offer the perfect blend of convenience and luxury with our in-unit laundry apartments. Designed with your needs in mind, our one, two, and three-bedroom floor plans provide a hassle-free living experience. No more trips to the laundromat—experience the joy of doing laundry in the comfort of your own home.\n\nBeyond in-unit laundry, Liberty Pointe boasts a wealth of amenities that enhance your lifestyle, including a sparkling pool, fitness center, and serene courtyard. Located in the vibrant Kennington-Ridgefield neighborhood, our community ensures you have everything you need at your fingertips. Discover the ease and comfort of living at Liberty Pointe, where modern convenience meets stylish living in Oklahoma City, OK.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and black appliances.",
        "public_id": "019d01a5-0ee3-710f-9412-a7df65ffb9ab",
        "storage_key": "property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in OKC, OK",
      "seo_description": "Discover in-unit laundry at Liberty Pointe in Oklahoma City, OK. Enjoy comfortable living with modern amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-okc-73135",
      "search_query": "air conditioned apartments near OKC 73135",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near OKC 73135",
      "h2_subtitle": "Experience comfort in our air conditioned apartments close to OKC 73135. Liberty Pointe offers modern amenities for your ideal home.",
      "page_copy": "Stay cool and comfortable at Liberty Pointe, where our air conditioned apartments near OKC 73135 cater to your every need. Enjoy the relief of stepping into a refreshing, climate-controlled environment in our spacious one, two, or three-bedroom floor plans. Our commitment to your comfort extends beyond air conditioning, providing an inviting lifestyle with exceptional amenities.\n\nLocated in the charming Kennington-Ridgefield neighborhood, Liberty Pointe presents a welcoming community atmosphere. You'll not only appreciate the comfort of air conditioning but also access to a sparkling pool, fitness center, and serene outdoor spaces, ideal for relaxation and socializing. Discover the benefits of choosing Liberty Pointe as your home near OKC 73135, where convenience and comfort go hand in hand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and black appliances.",
        "public_id": "019d01a5-0ee3-710f-9412-a7df65ffb9ab",
        "storage_key": "property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near OKC 73135",
      "seo_description": "Find comfort at Liberty Pointe, featuring air conditioned apartments near OKC 73135. Enjoy modern amenities and a perfect location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-kennington-ridgefield-ok",
      "search_query": "one bedroom apartments kennington-ridgefield ok",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Kennington-Ridgefield",
      "h2_subtitle": "Explore cozy one-bedroom apartments in Kennington-Ridgefield, Oklahoma City. Liberty Pointe offers modern living with top amenities.",
      "page_copy": "Discover the charm of one-bedroom apartments at Liberty Pointe, located in the desirable Kennington-Ridgefield neighborhood of Oklahoma City. Our thoughtfully designed one-bedroom floor plans offer the perfect blend of comfort and style, making Liberty Pointe an ideal choice for those seeking an inviting living experience.\n\nSituated in a vibrant community, our apartments go beyond just providing a home. Enjoy luxurious amenities such as a sparkling pool, well-equipped fitness center, and relaxing courtyard spaces. At Liberty Pointe, you'll find not just a one-bedroom apartment but a place where you can truly feel at home in Kennington-Ridgefield. Experience the convenience and style of living at Liberty Pointe today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and black appliances.",
        "public_id": "019d01a5-0ee3-710f-9412-a7df65ffb9ab",
        "storage_key": "property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Kennington-Ridgefield",
      "seo_description": "Find modern one-bedroom apartments at Liberty Pointe in Kennington-Ridgefield. Enjoy top amenities and a prime location in Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-oklahoma-city-ok",
      "search_query": "two bedroom apartments oklahoma city ok",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Oklahoma City, OK",
      "h2_subtitle": "Find spacious two-bedroom apartments at Liberty Pointe in Oklahoma City, OK. Enjoy a blend of luxury and convenience in every home.",
      "page_copy": "At Liberty Pointe, our two-bedroom apartments in Oklahoma City, OK offer spacious living with floor plans tailored to suit your lifestyle. Each unit provides ample space for living, entertaining, and relaxation, all within a vibrant community setting. Nestled in the bustling neighborhood of Kennington-Ridgefield, Liberty Pointe offers residents a perfect blend of convenience and comfort.\n\nBeyond the spacious interiors, enjoy access to an array of amenities that elevate daily living. With a sparkling pool to unwind in, a fitness center for staying active, and inviting outdoor spaces, our community is designed to support a well-rounded lifestyle. Discover the benefits of choosing Liberty Pointe's two-bedroom apartments in Oklahoma City, where comfort meets sophistication.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and black appliances.",
        "public_id": "019d01a5-0ee3-710f-9412-a7df65ffb9ab",
        "storage_key": "property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Oklahoma City, OK",
      "seo_description": "Discover spacious two-bedroom apartments at Liberty Pointe in Oklahoma City, OK. Enjoy luxurious amenities and a welcoming community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6321002732584960",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-73135",
      "search_query": "three bedroom apartments near 73135",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 73135",
      "h2_subtitle": "Explore our three-bedroom apartments near 73135 at Liberty Pointe. Enjoy spacious living and modern amenities in a prime location.",
      "page_copy": "Discover the convenience and comfort of three-bedroom apartments at Liberty Pointe, located near the 73135 area. Our expansive floor plans are designed to accommodate families or those needing extra space, ensuring a comfortable lifestyle filled with modern amenities. Experience a sense of community in the Kennington-Ridgefield neighborhood, known for its welcoming atmosphere.\n\nIn addition to spacious interiors, residents of Liberty Pointe enjoy access to a range of luxurious amenities. Whether it's basking by the sparkling pool, working out in the fitness center, or relaxing in the serene courtyard, our community provides the perfect setting for any lifestyle. Choose Liberty Pointe's three-bedroom apartments near 73135, where every family can find their ideal home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and black appliances.",
        "public_id": "019d01a5-0ee3-710f-9412-a7df65ffb9ab",
        "storage_key": "property/6321002732584960/019d01a5-0ee3-710f-9412-a7df65ffb9ab.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 73135",
      "seo_description": "Find spacious three-bedroom apartments at Liberty Pointe, near 73135. Enjoy modern amenities and a prime location in Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4784"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9147445369"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4057594888"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5XHZFHBD"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 5"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "f6e6d415-ff92-4cd6-8fa8-a70eac2b149b"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Vantage"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/dc681164-5434-4520-8e8c-c3b8c7f6f667/app.js?property=dc681164-5434-4520-8e8c-c3b8c7f6f667&propertyName=Liberty+Pointe&channelUuid=c248ec93-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47607690395"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IldVZXJvR28yZjhxL3E3aTBNbFZUZGc9PSIsInZhbHVlIjoiVUh6aVQxWmpwL2xDcEkyUjdwb29DQT09IiwibWFjIjoiNGZlYWY4ZjQzMmE2ZDY0NmNhNzNjNTVlYjU1MjJkYmM4ZGJiMjlhMjI0ZTY1Zjc3NmVkN2YzNGVhYzY3MWRlNCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "4784",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9147445369",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4057594888",
  "custom_google_gtm_id": "GTM-5XHZFHBD",
  "custom_rollout_phase": "Phase 5",
  "custom_rentgrata_token": "f6e6d415-ff92-4cd6-8fa8-a70eac2b149b",
  "custom_vibesites_theme": "Vantage",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/dc681164-5434-4520-8e8c-c3b8c7f6f667/app.js?property=dc681164-5434-4520-8e8c-c3b8c7f6f667&propertyName=Liberty+Pointe&channelUuid=c248ec93-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47607690395",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IldVZXJvR28yZjhxL3E3aTBNbFZUZGc9PSIsInZhbHVlIjoiVUh6aVQxWmpwL2xDcEkyUjdwb29DQT09IiwibWFjIjoiNGZlYWY4ZjQzMmE2ZDY0NmNhNzNjNTVlYjU1MjJkYmM4ZGJiMjlhMjI0ZTY1Zjc3NmVkN2YzNGVhYzY3MWRlNCJ9",
  "custom_audioeye_site_id": "f3847f59-350e-4e0b-bdf0-c105654a21ac",
  "custom_audioeye_site_hash": "6b92061566e6612a4252cabba197fb4f"
};

export const generatedAt = '2026-10-28T15:51:43.480Z';
